import React from "react";
import { Box, Flex, Image, Text, VStack } from "@chakra-ui/react";
import AboutUsImage from "../../assets/Landing/AboutUsImage.svg";

function About() {
  return (
    <Flex
      direction={{ base: 'column', md: 'row' }} // Imagen primero en móviles, fila normal en dispositivos más grandes
      align="center"
      justify="center"
      wrap="wrap" // Asegura que los elementos se envuelvan si no hay espacio suficiente
      id="About"
    >
      {/* Container de la imagen */}
      <Box
        w={{ base: 'full', md: '50%' }} // 100% en dispositivos móviles, 50% en dispositivos más grandes
        p={{ base: 5, md: 10 }} // Menos padding en dispositivos móviles
        display="flex"
        justifyContent={{ base: 'center', md: 'center' }} // Centrar contenido horizontalmente en todos los tamaños
        alignItems="center"
        order={{ base: 1, md: 2 }}
      >
        <Image src={AboutUsImage} alt="About Us" boxSize={{ base: '60%', md: '100%' }} fit="contain" />
      </Box>

      {/* Container de texto */}
      <Flex
        w={{ base: 'full', md: '50%' }} // 100% en dispositivos móviles, 50% en dispositivos más grandes
        p={{ base: 5, md: 10 }} // Menos padding en dispositivos móviles
        order={{ base: 2, md: 1 }}
        align="center"
        justify="center"
      >
        <VStack
          maxW="600px"
          align="flex-start"
          spacing={4} // 40px de separación entre párrafos
          width="full" // Asegura que VStack tome el ancho máximo de 600px o el ancho disponible
        >
          <Text
            color="#0D1216"
            fontFamily="Quicksand"
            fontSize={{ base: '36px', md: '48px' }} // Tamaño más pequeño en móviles
            fontWeight="700"
            lineHeight="1"
          >
            About <Text as="span" color="#90BCB5">TEA</Text>
          </Text>

          <Text
            color="#313C45"
            fontFamily="Quicksand"
            fontSize={{ base: '16px', md: '20px' }} // Tamaño más pequeño en móviles
            fontWeight="500"
            lineHeight="1.6" // 160%
          >
            At TEA, we're on a mission to transform the way children with Autism Spectrum Disorder (ASD) learn and communicate. Our team is dedicated to developing innovative technology solutions that empower children to enhance their non-verbal communication skills and emotional recognition abilities.
          </Text>

          <Text
            color="#313C45"
            fontFamily="Quicksand"
            fontSize={{ base: '16px', md: '20px' }} // Tamaño más pequeño en móviles
            fontWeight="500"
            lineHeight="1.6" // 160%
          >
            By providing engaging games and interactive experiences, we strive to create a supportive environment where every child can thrive. Join us in our journey to promote inclusion, empowerment, and a brighter future for individuals with ASD.
          </Text>
        </VStack>
      </Flex>
    </Flex>
  );
}

export default About;
